import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { FloatingShapes } from "@/components/Decor";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Identifiants invalides";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand relative overflow-hidden flex items-center justify-center px-4">
      <FloatingShapes className="opacity-60" />

      <Link to="/" className="absolute top-6 left-6 inline-flex items-center gap-2 text-ocean/60 hover:text-ocean text-sm" data-testid="back-home">
        <ArrowLeft size={16} /> Retour au site
      </Link>

      <div className="relative w-full max-w-md">
        <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-[0_30px_80px_-30px_rgba(11,39,66,0.3)] border border-ocean/5">
          <div className="text-center mb-8">
            <div className="inline-flex w-20 h-20 rounded-2xl bg-white border border-ocean/10 shadow-md items-center justify-center mb-4 p-2.5">
              <img src="/logo-ssp.png" alt="SSP" className="w-full h-full object-contain" />
            </div>
            <h1 className="font-display text-3xl text-ocean">Espace administrateur</h1>
            <p className="text-sm text-ocean/55 mt-2">Connectez-vous pour gérer les inscriptions</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block text-xs uppercase tracking-wider text-ocean/55 font-semibold mb-2">Email</label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-ocean/30" size={16} />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="admin-input-email"
                  placeholder="soutienscolaire.papara@gmail.com"
                  className="w-full pl-11 pr-4 py-3 rounded-xl border border-ocean/10 bg-sand/50 focus:bg-white focus:border-coral focus:ring-2 focus:ring-coral/20 transition-all text-sm text-ocean"
                  required
                />
              </div>
            </div>
            <div>
              <label className="block text-xs uppercase tracking-wider text-ocean/55 font-semibold mb-2">Mot de passe</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-ocean/30" size={16} />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="admin-input-password"
                  className="w-full pl-11 pr-4 py-3 rounded-xl border border-ocean/10 bg-sand/50 focus:bg-white focus:border-coral focus:ring-2 focus:ring-coral/20 transition-all text-sm text-ocean"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="w-full btn-pill btn-primary justify-center disabled:opacity-60"
            >
              {submitting ? "Connexion..." : "Se connecter"}
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-xs text-ocean/40">
          Accès réservé au personnel autorisé
        </p>
      </div>
    </div>
  );
}
